export const act_SetNotifications = (payload) => ({type:'SET_NOTIFICATIONS', payload})

export const act_ShowNotifications = (payload) => ({ type:'SHOW_NOTIFICATIONS', payload})

export const act_HideNotifications = () => ({ type:'HIDE_NOTIFICATIONS'})